export default [
  {
    path: 'sueldos',
    name: 'empresa.sueldos',
    redirect: { name: 'empresa.sueldos.home' },
    component: () => import('@/views/empresa/sueldos/SueldosEmpresaLayout.vue'),
    meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, modulo: 'sueldos' },
    children: [
      {
        path: '',
        name: 'empresa.sueldos.home',
        component: () => import('@/views/empresa/sueldos/SueldosEmpresaHome.vue'),
        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false },
      },
      {
        path: 'liquidaciones/:id',
        name: 'empresa.sueldos.liquidacion.detalle',
        component: () => import('@/components/shared/sueldos/LiquidacionDetalle.vue'),
        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false },
      },
    ],
  },
];
